import { IconButton, IconButtonProps } from '@mui/material'
import { SxProps, Theme } from '@mui/system'

interface RoundIconButtonProps extends Omit<IconButtonProps, 'children'> {
  children: React.ReactNode
  sx?: SxProps<Theme>
}

const RoundIconButton: React.FC<RoundIconButtonProps> = ({ children, sx = {}, ...props }) => {
  return (
    <IconButton
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        mr: 1,
        width: 25,
        height: 25,
        borderRadius: '50%',
        p: 0,
        '&:hover': { bgcolor: 'primary.dark' },
        ...sx,
      }}
      {...props}>
      {children}
    </IconButton>
  )
}

export default RoundIconButton
